<template>
  <article class="col-md-18">
    <h1>Rateplans</h1>
    <table class="table">
      <thead>
        <tr>
          <th scope="col">ID</th>
          <th scope="col">Name</th>
          <th scope="col">Jasper wireless code</th>
          <th scope="col">Communication plan</th>
          <th scope="col">enabled</th>
          <th scope="col"></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="plan in rateplans" :key="plan.id">
          <td>{{ plan.id }}</td>
          <td>{{ plan.displayName }}</td>
          <td>{{ plan.jasperWirelessCode }}</td>
          <td>{{ plan.commPlan }}</td>
          <td>{{ plan.enabled }}</td>
          <td>
            <a href="#" @click="edit(plan)" class="btn btn-primary btn-sm">
              Edit
            </a>
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td colspan="6">
            <a
              href="#"
              @click.prevent="create()"
              class="btn btn-primary btn-sm"
            >
              New
            </a>
          </td>
        </tr>
      </tfoot>
    </table>
  </article>
</template>

<script>
import axios from 'axios'

export default {
  name: 'Rateplans',
  data() {
    return {
      loading: false,
      rateplans: null,
    }
  },
  methods: {
    getRateplans() {
      this.loading = true
      axios
        .get('/rest/rateplan/all')
        .then(response => {
          this.rateplans = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    edit(plan) {
      this.$router.push(`/secure/rateplans/${plan.id}`)
    },
    create() {
      this.$router.push('/secure/rateplans/new')
    },
  },
  beforeMount() {
    this.getRateplans()
  },
}
</script>

<style lang="scss"></style>
